import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);

const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);

const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

import FanBudgetLanding from './content/pages/FanBudgetLanding';
import PublicInvoiceView from './content/pages/CustomerInvoiceView/PublicInvoiceView';
import SuspenseLoader from './components/SuspenseLoader';
import PublicInvoiceViewOld from './content/pages/CustomerInvoiceView/PublicInvoiceViewOld';
import PublicPurchaseOrderView from './content/pages/SupplierPurchaseOrderView/PublicPurchaseOrderView';
import PublicPurchaseOrderViewOld from './content/pages/SupplierPurchaseOrderView/PublicPurchaseOrderViewOld';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <FanBudgetLanding />
  },
  {
    path: '',
    children: [
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'public-invoice-view',
    element: <PublicInvoiceViewOld />,
    children: [
      {
        path: '',
        element: <PublicInvoiceViewOld />
      },
      {
        path: '*',
        element: <PublicInvoiceViewOld />
      }
    ]
  },
  {
    path: 'invoice',
    element: <PublicInvoiceView />,
    children: [
      {
        path: '',
        element: <PublicInvoiceView />
      },
      {
        path: '*',
        element: <PublicInvoiceView />
      }
    ]
  },
  {
    path: 'public-purchaseOrder-view',
    element: <PublicPurchaseOrderViewOld />,
    children: [
      {
        path: '',
        element: <PublicPurchaseOrderViewOld />
      },
      {
        path: '*',
        element: <PublicPurchaseOrderViewOld />
      }
    ]
  },
  {
    path: 'purchaseOrder',
    element: <PublicPurchaseOrderView />,
    children: [
      {
        path: '',
        element: <PublicPurchaseOrderView />
      },
      {
        path: '*',
        element: <PublicPurchaseOrderView />
      }
    ]
  }
];

export default routes;